"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.expire = exports.remove = exports.post = exports.get = void 0;
const config_1 = require("../config");
const eosio_1 = require("../eosio");
/**
 * Get Report
 *
 * @example
 *
 * detective.reports.get("eosnationftw").then(data => {
 *   console.log(data)
 * })
 */
function get(account) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!account) {
            throw new Error("[account] is required");
        }
        if (!config_1.settings.contract) {
            throw new Error("[settings.contract] is required");
        }
        const code = config_1.settings.contract;
        const scope = config_1.settings.contract;
        const table = "accounts";
        const lower_bound = account;
        const upper_bound = account;
        const json = true;
        const rows = yield config_1.settings.rpc.get_table_rows({ code, scope, table, lower_bound, upper_bound, json });
        if (!rows.rows.length) {
            throw new Error(`[account::${account}] does not exist`);
        }
        return rows.rows[0];
    });
}
exports.get = get;
/**
 * Post Report
 */
function post(profile) {
    return __awaiter(this, void 0, void 0, function* () {
        const action = actionPost(profile.account, profile.score, JSON.stringify(profile));
        return yield eosio_1.transact([action]);
    });
}
exports.post = post;
/**
 * Remove Report
 */
function remove(account) {
    return __awaiter(this, void 0, void 0, function* () {
        const action = actionRemove(account);
        return yield eosio_1.transact([action]);
    });
}
exports.remove = remove;
/**
 * Expire Report
 */
function expire(account) {
    return __awaiter(this, void 0, void 0, function* () {
        const action = actionExpire(account);
        return yield eosio_1.transact([action]);
    });
}
exports.expire = expire;
/**
 * @private
 */
function actionPost(account, score, metadata) {
    if (!account) {
        throw new Error("[account] is required");
    }
    if (!score) {
        throw new Error("[score] is required");
    }
    if (!metadata) {
        throw new Error("[metadata] is required");
    }
    if (!config_1.settings.contract) {
        throw new Error("[settings.contract] is required");
    }
    if (!config_1.settings.authorization) {
        throw new Error("[settings.authorization] is required");
    }
    // Input Validation
    score = Math.round(score);
    if (score < 0 || score > 100) {
        throw new Error("[score] must be between 0-100");
    }
    // Test to see if Metadata is valid JSON
    try {
        const json = JSON.parse(metadata);
        if (typeof json !== "object") {
            throw new Error("[metadata] must be an object");
        }
    }
    catch (e) {
        throw new Error("[metadata] is an invalid JSON");
    }
    return {
        account: config_1.settings.contract,
        name: "post",
        authorization: config_1.settings.authorization,
        data: {
            account,
            score,
            metadata,
        }
    };
}
/**
 * @private
 */
function actionRemove(account) {
    if (!account) {
        throw new Error("[account] is required");
    }
    if (!config_1.settings.contract) {
        throw new Error("[settings.contract] is required");
    }
    if (!config_1.settings.authorization) {
        throw new Error("[settings.authorization] is required");
    }
    return {
        account: config_1.settings.contract,
        name: "post",
        authorization: config_1.settings.authorization,
        data: {
            account,
            score: 0,
            metadata: "",
        }
    };
}
/**
 * @private
 */
function actionExpire(account) {
    if (!account) {
        throw new Error("[account] is required");
    }
    if (!config_1.settings.contract) {
        throw new Error("[settings.contract] is required");
    }
    if (!config_1.settings.authorization) {
        throw new Error("[settings.authorization] is required");
    }
    return {
        account: config_1.settings.contract,
        name: "expire",
        authorization: config_1.settings.authorization,
        data: {
            account,
        }
    };
}
//# sourceMappingURL=reports.js.map